import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { KeyRound } from "lucide-react";

export default function Referral() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const upperCode = code.trim().toUpperCase();
    if (upperCode === "DEV") {
      navigate("/dev-login");
    } else if (upperCode === "ADMIN") {
      navigate("/auth");
    } else {
      alert("Invalid Referral Code");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="w-full max-w-md shadow-2xl border-white/10 bg-black/40 backdrop-blur-xl text-white">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto bg-primary/20 p-4 rounded-full w-20 h-20 flex items-center justify-center mb-2">
            <KeyRound className="w-10 h-10 text-primary" />
          </div>
          <CardTitle className="text-3xl font-bold tracking-tight">Access Portal</CardTitle>
          <CardDescription className="text-slate-300 text-base">
            Please enter your referral code to continue
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-4">
              <label className="text-sm font-medium text-slate-200 block text-center">Referal :-</label>
              <Input
                type="text"
                placeholder="Enter referral code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="h-14 bg-white/5 border-white/10 text-white placeholder:text-slate-500 focus:ring-2 focus:ring-primary focus:border-primary text-center text-xl tracking-widest uppercase transition-all"
                autoFocus
              />
            </div>
            <Button
              type="submit"
              className="w-full h-12 text-lg font-medium transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
            >
              Verify Code
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
